import { NodeType } from 'shared/types/ingestion'
import {
  allNodesOfType,
  childNodesOfType,
} from 'components/utility/TreeHelpers'
import { INode } from 'shared/types/tree'
import { deleteNode, IWithNodeParams } from '../TreeActions'
import { doInBatches } from 'shared/utils'
import {
  appendNodeToTree,
  retrieveIds,
  NodeRequestParams,
} from '../TreeRequests'

const questionToAudioMap: Record<string, string> = {
  'Rehearsal Text':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_+SA_Rehearsal+Text+(Session+A+Video+1).mp3',
  'Write one phoneme (sound) in each sound box.':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_WWO_Listen-Up+(Sound+Boxes).mp3',
  'Decide where the word should be divided into syllables':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_WWO_Listen-Up+(Syllable+Boxes).mp3',
  'Put two syllables together':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_Work+Workout_Build+it+Up+_Syllables.mp3',
  'Put two of the syllables together to build a':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_Work+Workout_Build+it+Up+_Syllables.mp3',
  'Put one syllable from each column':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_Work+Workout_Build+it+Up+_Syllables.mp3',
  'sound (phoneme) at the start of the hill':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_CW_+Drills.mp3',
  "What parts of the word are spelled the way we'd expect":
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_CW_+Plays.mp3',
  'What parts of the word are spelled the way we’d expect':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_CW_+Plays.mp3',
  'Finish the sentence with the best Core Word':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_CW_+Reps.mp3',
  'Sound Tracker':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/1729883553653/20241025191233653/UP_Audio_Directions_SB_Sound%20Tracker.mp3',
  'Encoding Exercise Edit Training':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Edit+Training+(Word+Bank).mp3',
  'Part A Directions':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Comp-Training_Part+A.mp3',
  'Encoding Exercise Part A':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Comp-Training_Part+A.mp3',
  'Type each of your Core Words from this week three times, using a different creative style each time.':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Comp-Training_Part+A.mp3',
  'Part B Directions':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Comp-Training_Part+B.mp3',
  'Encoding Exercise Part B':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Comp-Training_Part+B.mp3',
  'words that have a schwa sound for the letters':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Comp-Training_Part+B.mp3',
  'Part C Directions':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SB_EE_+Comp-Training_Part+C.mp3',
  'Annotation Routine':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_SC_Annotation+Routine.mp3',
  'Read each onset and rime.':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_WWO_+Build-it-Up+(Onset-Rime).mp3',
  'Put one onset and one rime':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_WWO_+Build-it-Up+(Onset-Rime).mp3',
  'Switch Up':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_Switch-UP_Review+Session+A.mp3',
  'SWITCH-UP':
    'https://api-assignment-assets-production.s3.us-east-2.amazonaws.com/academy-uploads/drive-download-20241025T222902Z-001/UP_Audio_Directions_Switch-UP_Review+Session+A.mp3',
}

export function removeAttachmentListsFromQuestions(tree: INode) {
  const questions = allNodesOfType(tree, NodeType.Question)
  const toDelete: IWithNodeParams[] = []
  questions.forEach((q) => {
    const attachmentLists = childNodesOfType(q, NodeType.AttachmentsList)
    attachmentLists.forEach((al) => {
      toDelete.push({
        nodeId: al.id,
        treeId: al.tree_id,
        versionId: al.version,
      })
    })
  })
  doInBatches(toDelete, deleteNode)
}

export function getAllQuestions(tree: INode) {
  const sessionActivities = allNodesOfType(tree, NodeType.Activity).filter(
    (a) => a.title.includes('Session'),
  )
  const questions = sessionActivities.flatMap((s) =>
    allNodesOfType(s, NodeType.Question),
  )
  const questionsWithoutAudio: INode[] = []

  const newAttachmentLists = questions.reduce<NodeRequestParams[]>((acc, q) => {
    if (!q.description?.toUpperCase().includes('SLIDE')) return acc
    if (q.description.toUpperCase().includes('BREAK IT UP')) return acc
    if (q.description.toUpperCase().includes('BUILD IT UP')) return acc

    const qtype = Object.keys(questionToAudioMap).find((key) => {
      return q.description?.includes(key)
    })
    if (!qtype) {
      questionsWithoutAudio.push(q)
    } else {
      const newAttachmentList = {
        title: 'Attachments',
        body: {
          studentFacing: true,
        },
        type: NodeType.AttachmentsList,
        leaves: [
          {
            type: 'attachment',
            body: {
              file: {
                data: {
                  name: qtype + '.mp3',
                  type: 'audio/mpeg',
                  url: questionToAudioMap[qtype],
                },
                id: qtype,
                mimeType: 'audio/mpeg',
                name: qtype + '.mp3',
                type: 'audio/mpeg',
                url: questionToAudioMap[qtype],
              },
            },
          },
        ],
      }
      acc.push({
        ...retrieveIds(q),
        ...newAttachmentList,
      })
    }
    return acc
  }, [])
  doInBatches(newAttachmentLists, appendNodeToTree)
}
